var map = {
	"./anthropic.svg": [
		4134,
		134
	],
	"./claude-4-opus.svg": [
		3449,
		449
	],
	"./claude-haiku-35.svg": [
		4518,
		518
	],
	"./claude-haiku-45.svg": [
		4679,
		679
	],
	"./claude-opus-45.svg": [
		4384,
		384
	],
	"./claude-opus-46.svg": [
		5395,
		395
	],
	"./claude-sonnet-37.svg": [
		2243,
		243
	],
	"./claude-sonnet-4.svg": [
		171,
		171
	],
	"./claude-sonnet-45.svg": [
		3196,
		196
	],
	"./claude-sonnet-46.svg": [
		4895,
		895
	],
	"./deepseek-r1.svg": [
		5070,
		70
	],
	"./deepseek-v3.svg": [
		904,
		904
	],
	"./gemini-15-flash.svg": [
		9927,
		927
	],
	"./gemini-15-pro.svg": [
		8708,
		708
	],
	"./gemini-25-flash-lite.svg": [
		6163,
		163
	],
	"./gemini-25-flash.svg": [
		7190,
		190
	],
	"./gemini-25-pro.svg": [
		6009,
		9
	],
	"./gemini-3-flash.svg": [
		1094,
		94
	],
	"./gemini-3-pro.svg": [
		7641,
		641
	],
	"./gemini-31-pro.svg": [
		7118,
		118
	],
	"./google.svg": [
		1059,
		59
	],
	"./gpt-41-mini.svg": [
		8473,
		473
	],
	"./gpt-41-nano.svg": [
		3174,
		174
	],
	"./gpt-41.svg": [
		3651,
		651
	],
	"./gpt-5-codex.svg": [
		429,
		429
	],
	"./gpt-5-mini.svg": [
		9781,
		781
	],
	"./gpt-5-nano.svg": [
		9338,
		338
	],
	"./gpt-5.svg": [
		1855,
		855
	],
	"./gpt-51-codex-mini.svg": [
		4706,
		706
	],
	"./gpt-51.svg": [
		9820,
		820
	],
	"./gpt-54-pro.svg": [
		5147,
		147
	],
	"./gpt-54.svg": [
		1553,
		553
	],
	"./kimi-k2-reasoning.svg": [
		8597,
		597
	],
	"./kimi-k2.svg": [
		4422,
		422
	],
	"./nova-2-lite.svg": [
		7066,
		66
	],
	"./nova-2-pro.svg": [
		827,
		827
	],
	"./o3.svg": [
		3596,
		596
	],
	"./o4-mini-high.svg": [
		6230,
		230
	],
	"./openai.svg": [
		3064,
		64
	],
	"./openrouter.svg": [
		4137,
		137
	],
	"./qwen3-235b-reasoning.svg": [
		6848,
		848
	],
	"./qwen3-235b.svg": [
		3195,
		195
	],
	"./route-ai.svg": [
		488,
		488
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2015;
module.exports = webpackAsyncContext;